<template>
  <div>
    <span v-translate>{{ label }}</span>
    <div v-for="(document, key) in documents" :key="key">
      <div v-for="(file, index) in document.files" :key="index" class="document">
        <div><a :href="file.url" target="_blank" v-html="`${file.name}`" download /></div>
        <div v-if="file.deleteUrl">
          <delete-file-component :document="document" :file="file" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { Document } from '@/classes/case/Document'
  import DeleteFileComponent from '@/components/layout/utility/DeleteFileComponent'

  export default {
    name: 'documents-component',
    components: {
      DeleteFileComponent
    },
    props: {
      label: {
        type: String,
        required: false
      },
      documents: {
        type: Array,
        validator: (prop) => prop.every(e => e instanceof Document),
        required: true
      }
    }
  }
</script>
<style lang="sass" scoped>
  .document
    display: table
    div
      display: table-cell
      vertical-align: middle
</style>
